export const LOWER_LEFT_POINT='LOWER_LEFT_POINT';
export const UPPER_RIGHT_POINT='UPPER_RIGHT_POINT';
export const FEATURE_NAME='featureName';
export const ZOOM_INCREMENT=0.5;